import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import LinearProgress from '@mui/material/LinearProgress'
import ButtonComponent from 'components/button'
import FeatureManagementSettings from 'components/settings-admin/FeatureManagementSettings'
import UserManagementSettings from 'components/settings-admin/UserManagementSettings'
import CircularProgressWithLabel from 'components/table/CircularProgressLabel'
import ToastComponent from 'components/toast'
import { useState } from 'react'
import { UpdateSchoolInputProps } from 'types/SchoolTypes'
import { isProd } from 'utils/constants'
import { updateSchool } from 'utils/schools'
import { MessageProps, SchoolUsersProps } from 'utils/types'
import './index.css'

function Index({
  schoolUsers,
  onUpdate,
}: {
  schoolUsers?: SchoolUsersProps | null
  onUpdate: (cb?: () => void) => void
}): JSX.Element {
  // All hooks at the top
  const [isLoading, setIsLoading] = useState<string>('')
  const [msg, setMsg] = useState<MessageProps>()

  if (!schoolUsers) return <LinearProgress />

  // Now destructure, etc.
  const {
    schoolName,
    isCarpoolActive,
    isCarpoolManagementActive,
    isDismissalManagementActive,
    isCommunityAnnouncementsActive,
    schoolAdmins,
    schoolDismissalSession,
  } = schoolUsers

  // Hooks: Since we are using the props, which are updated by parent using callback directly, no need for hooks to keep and update local state

  // Handlers
  const handleUpdate = async (body: UpdateSchoolInputProps, loadingMsg?: string, cb?: () => void) => {
    setIsLoading(loadingMsg || 'Updating school...')
    const { msg, error } = await updateSchool(schoolName, body)
    if (error) setMsg(msg)
    else
      onUpdate(() => {
        setIsLoading('')
        cb?.()
      })
  }

  return (
    <Box gap={3}>
      {/* Loading indicator for backend API calls */}
      {isLoading && (
        <Dialog open={true}>
          <DialogTitle>{isLoading}</DialogTitle>
          <CircularProgressWithLabel />
        </Dialog>
      )}

      {isCarpoolActive && (
        <Box
          display='flex'
          flexDirection={{ xs: 'column', lg: 'row' }}
          width='100%'
          alignItems='stretch'
          gap={{ lg: 2 }}
          sx={{
            '& > *': {
              flex: 1,
            },
          }}
        >
          <FeatureManagementSettings
            initialIsCarpoolManagementActive={isCarpoolManagementActive}
            initialIsDismissalManagementActive={isDismissalManagementActive}
            initialIsCommunityAnnouncementsActive={isCommunityAnnouncementsActive}
            carpoolManagementDisabled={true} // FIXME: Make Carpool Management toggleable
            dismissalManagementDisabled={schoolDismissalSession ? true : isProd()}
            communityAnnouncementsDisabled={isProd()}
            onSave={handleUpdate}
          />

          <UserManagementSettings initialAdmins={schoolAdmins} onSave={handleUpdate} />
        </Box>
      )}

      {/***************** Display messages *****************/}
      {msg && (
        <ToastComponent style={msg?.style} heading={msg?.heading} text={msg?.text} onClose={() => setMsg(undefined)} />
      )}

      {/***************** Contact us *****************/}
      <Box display='flex' flexDirection='column' paddingTop={5}>
        <ButtonComponent
          size='small'
          variant='text'
          color='primary'
          text='Questions? Click here to email us.'
          href='mailto:support@carpool.school'
        />
        <ButtonComponent
          size='small'
          variant='text'
          color='primary'
          text='More questions? Call us!'
          href='tel:+17546667665'
        />
      </Box>
    </Box>
  )
}

export default Index
